import { useCallback } from 'react';
import { GetTicketDetailsRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/TicketsRpc.resources';
import { getTicketDetailsParams } from '../data/useTicket';
import { GetRelevantThreadsForUserRpc } from '../../__generated__/chirp/com/hubspot/support/portal/rpc/ThreadViewRpc.resources';
import { getRelevantThreadsParams } from '../data/useTicketThreads';
import { useIsPreview } from './useIsPreview';
export function usePrefetchTicketData() {
  const isPreview = useIsPreview();
  return useCallback(ticketId => {
    if (isPreview) return;
    GetTicketDetailsRpc.getPromise(getTicketDetailsParams(ticketId)).catch(() => {});
    GetRelevantThreadsForUserRpc.getPromise(getRelevantThreadsParams(ticketId)).catch(() => {});
  }, [isPreview]);
}